<div *ngIf="selectableCompanies?.length > 0" class="select-container">
  <mat-form-field appearance="outline">
    <mat-select
      matInput
      placeholder="Kies een bedrijf"
      [(ngModel)]="selectedCompany"
      (ngModelChange)="selectedCompanyChanged()"
      [compareWith]="compareEntities"
    >
      <mat-option *ngFor="let option of selectableCompanies" [value]="option">
        {{ option.regularName }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
